import { useJnjBranding } from "@jmc/utils/hooks/useJnjBranding";
import React from "react";

import { OneTrustWebFormBranded } from "./OneTrustWebFormBranded";
import { OneTrustWebFormLegacy } from "./OneTrustWebFormLegacy";

interface OneTrustWebFormProps {
    id: string;
    buttonId: string;
    thankYouUrl: string;
}

// Extend the Window interface to include the OneTrust property
declare global {
    interface Window {
        OneTrust?: {
            webform?: {
                InstallCP: (buttonId: string, options: Record<string, unknown>) => void;
            };
        };
    }
}

export const OneTrustWebForm = (props: OneTrustWebFormProps): JSX.Element => {
    const { jnjFullBranded } = useJnjBranding();

    return jnjFullBranded ? <OneTrustWebFormBranded {...props} /> : <OneTrustWebFormLegacy {...props} />;
};

export default OneTrustWebForm;
